###
  Migrated from https://github.com/angular/angular.js/blob/v1.2.x/@ng/filter/filters.js
  formatNumber()
###
angular
	.module 'App.Filter'

	.filter 'wmNumber',
		[
			->
				return (number, groupSeparator = ' ', decimalSeparator = ',', fractionSize = 2, pattern = {}) ->
					if angular.isString(number) and !isNaN(parseFloat(number))
						number = parseFloat(number)

					if angular.isNumber(number) and !angular.isObject(number)
						defaultPattern =
							gSize: 3
							lgSize: 3
							macFrac: 0
							maxFrac: 3
							minFrac: 0
							minInt: 1
							negPre: '-'
							negSuf: ''
							posPre: ''
							posSuf: ''

						pattern = angular.extend({}, defaultPattern, pattern)

						decSep = '.'
						isNegative = number < 0
						number = Math.abs(number)
						numStr = number + ''
						formattedText = ''
						parts = []
						hasExponent = false

						if numStr.indexOf('e') != -1
							match = numStr.match(/([\d\.]+)e(-?)(\d+)/)
							if match and match[2] == '-' and match[3] > fractionSize + 1
								numStr = '0'
								number = 0
							else
								formattedText = numStr
								hasExponent = true

						if !hasExponent
							fractionLen = (numStr.split(decSep)[1] or '').length
							# determine fractionSize if it is not specified
							if angular.isUndefined(fractionSize)
								fractionSize = Math.min(Math.max(pattern.minFrac, fractionLen), pattern.maxFrac)
							# safely round numbers in JS without hitting imprecisions of floating-point arithmetics
							# inspired by:
							# https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
							number = +(Math.round(+(number.toString() + 'e' + fractionSize)).toString() + 'e' + -fractionSize)

							if number == 0
								isNegative = false
							fraction = ('' + number).split(decSep)
							whole = fraction[0]
							fraction = fraction[1] or ''
							i = undefined
							pos = 0
							lgroup = pattern.lgSize
							group = pattern.gSize

							if whole.length >= lgroup + group
								pos = whole.length - lgroup
								i = 0
								while i < pos
									if (pos - i) % group == 0 and i != 0
										formattedText += groupSeparator
									formattedText += whole.charAt(i)
									i++
							i = pos
							while i < whole.length
								if (whole.length - i) % lgroup == 0 and i != 0
									formattedText += groupSeparator
								formattedText += whole.charAt(i)
								i++
							# format fraction part.
							while fraction.length < fractionSize
								fraction += '0'

							if fractionSize and fractionSize != '0'
								formattedText += decimalSeparator + fraction.substr(0, fractionSize)
						else
							if fractionSize > 0 and number > -1 and number < 1
								formattedText = number.toFixed(fractionSize)
						parts.push if isNegative then pattern.negPre else pattern.posPre
						parts.push formattedText
						parts.push if isNegative then pattern.negSuf else pattern.posSuf
						number = parts.join ''
					return number
		]
